





















































import VueOptions from '@utils/VueOptions'

settings =
  name: "ShoppingCartMiniItemCard"

  vue:
    props: ['lineItems', 'actions']

    methods:
      eventForLineItem: (lineItem)-> @ctxEvent lineItem
      thumbUrlForEvent: (event) -> event?.image?.thumb_url

      navigateToEventDetails: (event) -> @$router.push { name: 'EventFeedDetails', params: { eventId: event.id } }

      spaceFor: (lineItem) -> @eventForLineItem(lineItem)?.spaces?[lineItem.space_name]
      spaceTypeFor: (lineItem) -> @spaceFor(lineItem)?.type
      spacePriceFor: (lineItem) -> lineItem.total_price_in_dollars
      spaceIconFor: (lineItem) -> @iconForSpace(@spaceFor(lineItem))

      showOriginalPriceFor: (lineItem) ->
        isNotSamePrice = lineItem.total_original_price_in_dollars isnt @spacePriceFor(lineItem)
        isNotSamePrice

export default VueOptions.vue settings
